<template>
<div class="result-analysis-wrapper">
  <factor-source-stack-chart
    :source-name-configs="sourceNameConfigs"
    :data-map="dataMap"
    :data-time-formatter="dataTimeFormatter"
  />

  <factor-source-avg-pie-chart
    :source-name-configs="sourceNameConfigs"
    :data-map="dataMap"
  />

  <factor-source-stack-percentage-chart
    v-model="dataTime"
    :source-name-configs="sourceNameConfigs"
    :data-map="dataMap"
    :data-time-formatter="dataTimeFormatter"
  />

  <factor-source-pie
    :source-name-configs="sourceNameConfigs"
    :data-map="dataMap"
    :data-time="dataTime"
    :data-time-formatter="dataTimeFormatter"
  />
</div>
</template>

<script>
import BaseResult from './BaseResult'
import ChartStyle from '../../../../../../components/DataChart/ChartStyle'
import FactorSourceStackChart from '../FactorSourceStackChart'
import FactorSourceAvgPieChart from '../FactorSourceAvgPieChart'
import FactorSourceStackPercentageChart from '../FactorSourceStackPercentageChart'
import FactorSourcePie from '../FactorSourcePie'

export default {
  name: 'ResultAnalysis',
  label: '来源解析结果',
  dataKey: 'ResultAnalysis',
  extends: BaseResult,
  components: {FactorSourcePie, FactorSourceStackPercentageChart, FactorSourceAvgPieChart, FactorSourceStackChart},
  data: () => ({
    sourceNames: Object.freeze([]),
    dataTime: null
  }),
  computed: {
    sourceMap () {
      return this.sources.reduce((map, source) => {
        map[source.id] = source
        return map
      }, {})
    },
    sourceNameConfigs () {
      const {sourceMap} = this
      const {COLORS} = ChartStyle
      let index = 0
      return this.sourceNames.map(sourceName => {
        const source = sourceMap[sourceName]
        return {
          id: source ? source.id : sourceName,
          name: source ? source.name : sourceName,
          color: source ? source.color : COLORS[index++]
        }
      })
    },
    dataMap () {
      return this.shareData.timeSources.reduce((map, data) => {
        const {dataTime} = data
        let newData = map[dataTime]

        if (!newData) {
          newData = map[dataTime] = {
            dataTime
          }
        }

        const {contribution} = data
        newData[data.name] = contribution === -99999 || !Number.isFinite(contribution) ? null : Number(contribution.toFixed(2))
        return map
      }, {})
    }
  },
  methods: {
    renderData () {
      const {factorSources} = this.shareData
      this.sourceNames = Object.freeze([...new Set(factorSources.map(factorSource => factorSource.name))])
      this.dataTime = new Date(Object.keys(this.dataMap)[0]).format(this.dataTimeFormatter)
    }
  },
  created () {
    this.renderData()
  }
}
</script>

<style lang="scss" scoped>
.result-analysis-wrapper {
  display: grid;
  grid-template: {
    rows: repeat(2, minmax(300px, 1fr));
    columns: auto 350px;
  };
  grid-gap: 12px;
  overflow: auto;

  > * {
    min: {
      width: 0;
      height: 0;
    };
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/ResultComponents/04ResultAnalysis.vue